import CategoryLabel from '../category/CategoryLabel';
import Paragraph from '../common/Paragraph';
import TitleH3 from '../common/TitleH3';
import DateLabel from '../date/DateLabel';
import { CardInfo } from '../types';
import LazyYoutube from '../video/LazyYoutube';
import PlayVideoIcon from '../../../../public/svg/play_video.svg';
import DirectusImage from '../image/DirectusImage';

type CardType = 'default' | 'side' | 'single';

interface CardProps extends CardInfo {
  type?: CardType;
  displayDescription?: boolean;
  videoId: string;
  style?: string;
  duration?: string;
}

function DefaultCard({
  category,
  isoDate,
  title,
  videoId,
  description,
  displayDescription = false,
  style,
  duration,
}: CardProps) {
  return (
    <div className={`card card-compact relative shadow-none md:h-60 ${style}`}>
      <div className="relative w-full md:w-[560px]">
        <div className="relative mb-[20px]">
          <LazyYoutube videoId={videoId} styles="h-[224px] md:h-[310px]" />
          {duration && (
            <div className="absolute bottom-[20px] right-[20px] flex max-w-max items-center gap-2.5">
              <DirectusImage
                src={PlayVideoIcon}
                alt="Visionner la galerie video"
                dimension={{ width: 20, height: 20 }}
              />
              <span className="rounded bg-white p-[5px] text-xs font-semibold uppercase text-gray-400 backdrop-blur-sm">
                {duration}
              </span>
            </div>
          )}
        </div>
        <div className="h-[20px]">
          {category && <CategoryLabel category={category} type="blur" />}
        </div>
        <div className="my-[10px]">
          <TitleH3
            size={'medium'}
            titleUpperCase={false}
            styles="font-medium line-clamp-3 md:line-clamp-2 h-20 md:h-14"
            heading={false}
          >
            {title}
          </TitleH3>
        </div>
        {isoDate && <DateLabel isoDate={isoDate} color="lighter" styles="text-xs" />}
        {displayDescription && <Paragraph>{description}</Paragraph>}
      </div>
    </div>
  );
}

function SideCard({
  title,
  videoId,
  description,
  displayDescription = false,
  duration,
}: CardProps) {
  return (
    <div className="card shadow-xl lg:card-side">
      <div className="relative flex min-h-96 w-5/12">
        <LazyYoutube videoId={videoId} />
        {duration}
      </div>
      <div className="w-7/12 p-5">
        <h2 className="card-title">{title}</h2>
        {displayDescription && <Paragraph>{description}</Paragraph>}
        <div className="card-actions justify-end">
          <button className="btn btn-primary">Listen</button>
        </div>
      </div>
    </div>
  );
}

function SingleCard({ videoId, style }: CardProps) {
  return (
    <div className={`card card-compact relative shadow-none md:h-60 ${style}`}>
      <div className="relative w-full">
        <div className="relative mb-[20px]">
          <LazyYoutube videoId={videoId} styles="h-[400px] sm:h-[300px] lg:h-[600px]" autoPlay={true} />
        </div>
      </div>
    </div>
  );
}

export default function CardVideo(props: CardProps) {
  switch (props.type) {
    case 'default':
      return <DefaultCard {...props} style={props.style} />;
    case 'single':
      return <SingleCard {...props} style={props.style} />;
    case 'side':
      return <SideCard {...props} />;
    default:
      return null;
  }
}
